export { SchoolDetailsPage } from './SchoolDetailsPage'
